<template>
  <v-card
    class="mx-auto overflow-visible"
    width="580px"
    style="margin-top: 0px; margin-bottom: 0px; z-index: 99"
    outlined
  >
    <div>
      <v-list-item three-line>
        <v-list-item-content class="overflow-visible d-block">
          <v-row class="align-center">
            <v-col cols="10">
              <v-list-item-title class="headline mb-2"
                >Tìm kiếm nâng cao</v-list-item-title
              >
            </v-col>
            <v-col cols="2" class="text-right">
              <v-icon aria-label="Close" @click="closeMenuPopup"
                >mdi-close</v-icon
              >
            </v-col>
          </v-row>
          <v-divider style="margin-bottom: 20px"></v-divider>
          <v-row>
            <div  style="max-height: 650px; overflow: auto;" id="style-2">
              <v-col cols="12">
                <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin chăm sóc</div>
                <v-row>
                  <v-col cols="5" class="d-flex align-center pl-6">
                    Quản lý lớp
                  </v-col>
                  <v-col cols="7">
                    <v-autocomplete
                      @change="toggleSelectTeacher()"
                      v-model="innerFilterForm.homeroomTeacherIds"
                      :items="listGVCNV2"
                      item-text="name"
                      item-value="id"
                      no-data-text="Không có dữ liệu"
                      :placeholder="
                  innerFilterForm.hasNoTeacher
                    ? 'Không có quản lý lớp'
                    : 'Chọn quản lý lớp'
                "
                      clearable
                      multiple
                      hide-details
                      outlined
                      dense
                      small-chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.homeroomTeacherIds, item.id)">{{handleCutChipText(item.name)}}</v-chip>
                      </template>
                      <template v-slot:prepend-item>
                        <v-list-item
                          ripple
                          @mousedown.prevent
                          @click="toggleHasNoTeacher"
                        >
                          <v-list-item-action>
                            <v-icon
                              :color="
                          innerFilterForm.headTeacher.length > 0
                            ? 'indigo darken-4'
                            : ''
                        "
                            >
                              {{
                                innerFilterForm.hasNoTeacher
                                  ? "mdi-checkbox-marked"
                                  : "mdi-checkbox-blank-outline"
                              }}
                            </v-icon>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>
                              Không có quản lý lớp
                            </v-list-item-title>
                          </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row v-if="$route.query.schoolLevel === 'primary'">
                  <v-col cols="5" class="d-flex align-center pl-6">
                    Số ngày chưa chăm sóc
                    <v-tooltip top>
                      <template v-slot:activator="{attrs, on}">
                        <v-icon style="margin-left: 4px;" small v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                      </template>
                      <span>Tính từ mốc chăm sóc có trạng thái hoàn thành gần nhất</span>
                    </v-tooltip>
                  </v-col>
                  <v-col cols="7">
                    <v-row>
                      <v-col cols="12">
                        <div class="d-flex">
                          <v-text-field
                            v-model="innerFilterForm.numberLastestCareDateFrom"
                            style="margin-top: 2px; padding-top: 0"
                            type="number"
                            min="0"
                            class="custom-input-number"
                            :class="required ? 'required' : ''"
                            outlined
                            dense
                            hide-details
                            @change="changeNumberLastCare('from')"
                            @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                          >
                            <template v-slot:prepend-inner>
                              <div class="content-number d-flex align-center mt-1" :style="{color: required ? '#FF6B69' : ''}">Từ</div>
                            </template>
                            <template v-slot:append>
                              <div class="mt-1 content-number" :style="{color: required ? '#FF6B69' : ''}">Ngày</div>
                            </template>
                          </v-text-field>
                          <v-text-field
                            v-model="innerFilterForm.numberLastestCareDateTo"
                            style="margin-top: 2px; padding-top: 0"
                            type="number"
                            class="custom-input-number ml-2"
                            :class="required ? 'required' : ''"
                            :min="innerFilterForm.numberLastestCareDateFrom"
                            @change="changeNumberLastCare('to')"
                            @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                            outlined
                            dense
                            hide-details
                          >
                            <template v-slot:prepend-inner>
                              <div class="content-number d-flex align-center mt-1" :style="{color: required ? '#FF6B69' : ''}">Đến</div>
                            </template>
                            <template v-slot:append>
                              <div class="mt-1 content-number" :style="{color: required ? '#FF6B69' : ''}">Ngày</div>
                            </template>
                          </v-text-field>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin lọc học sinh đặc biệt</div>
                <v-row>
                  <v-col cols="5" class="d-flex align-center pl-6">
                    <v-checkbox
                      label="Nghỉ không phép"
                      v-model="specialCareFilter.studentOff"
                      hide-details
                      class="mt-0"
                      color="green"
                      on-icon="mdi-checkbox-outline"
                      @change="(val) => {
                          if(!val) {
                            innerFilterForm.numberStudentOff = ''
                            innerFilterForm.typeStudentOff = ''
                          }
                        }"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      type="number"
                      class="custom-compare-input"
                      :disabled="!specialCareFilter.studentOff"
                      v-model="innerFilterForm.numberStudentOff"
                      @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                      min="0"
                    >
                      <template v-slot:append>
                        buổi
                      </template>
                      <template v-slot:prepend-inner>
                        <v-select
                          hide-details
                          style="width: 130px; padding: 0"
                          dense
                          placeholder="So sánh"
                          class="custom-solo-select mt-0"
                          solo
                          item-value="value"
                          item-text="label"
                          v-model="innerFilterForm.typeStudentOff"
                          :items="commonCompareOptions"
                          clearable
                        >
                        </v-select>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="d-flex align-center pl-6">
                    <v-checkbox
                      label="Đi muộn về sớm"
                      hide-details
                      class="mt-0"
                      color="green"
                      on-icon="mdi-checkbox-outline"
                      v-model="specialCareFilter.studentLateEarly"
                      @change="(val) => {
                          if(!val) {
                            innerFilterForm.numberStudentLateEarly = ''
                            innerFilterForm.typeStudentLateEarly = ''
                          }
                        }"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      class="custom-compare-input"
                      v-model="innerFilterForm.numberStudentLateEarly"
                      :disabled="!specialCareFilter.studentLateEarly"
                      type="number"
                      @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                      min="0"
                    >
                      <template v-slot:append>
                        buổi
                      </template>
                      <template v-slot:prepend-inner>
                        <v-select
                          hide-details
                          style="width: 130px; padding: 0"
                          dense
                          placeholder="So sánh"
                          class="custom-solo-select mt-0"
                          solo
                          item-value="value"
                          item-text="label"
                          :items="commonCompareOptions"
                          v-model="innerFilterForm.typeStudentLateEarly"
                          clearable
                        >
                        </v-select>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="d-flex align-center pl-6">
                    <v-checkbox
                      label="Không làm bài tập"
                      hide-details
                      class="mt-0"
                      color="green"
                      on-icon="mdi-checkbox-outline"
                      v-model="specialCareFilter.studentHw"
                      @change="(val) => {
                          if(!val) {
                            innerFilterForm.numberStudentHw = ''
                            innerFilterForm.typeStudentHw = ''
                          }
                        }"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      class="custom-compare-input"
                      :disabled="!specialCareFilter.studentHw"
                      v-model="innerFilterForm.numberStudentHw"
                      type="number"
                      @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                      min="0"
                    >
                      <template v-slot:append>
                        bài
                      </template>
                      <template v-slot:prepend-inner>
                        <v-select
                          hide-details
                          style="width: 130px; padding: 0"
                          dense
                          placeholder="So sánh"
                          class="custom-solo-select mt-0"
                          solo
                          item-value="value"
                          item-text="label"
                          :items="commonCompareOptions"
                          v-model="innerFilterForm.typeStudentHw"
                          clearable
                        >
                        </v-select>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" class="d-flex align-center pl-6">
                    <v-checkbox
                      label="Điểm kiểm tra thấp"
                      hide-details
                      class="mt-0"
                      color="green"
                      on-icon="mdi-checkbox-outline"
                      v-model="innerFilterForm.studentTestLow"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="d-flex align-center pl-6">
                    <v-checkbox
                      label="Hủy buổi học"
                      hide-details
                      class="mt-0"
                      color="green"
                      on-icon="mdi-checkbox-outline"
                      v-model="specialCareFilter.studentCancelLesson"
                      @change="(val) => {
                          if(!val) {
                            innerFilterForm.numberStudentCancelLesson = ''
                            innerFilterForm.typeStudentCancelLesson = ''
                          }
                        }"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      class="custom-compare-input"
                      :disabled="!specialCareFilter.studentCancelLesson"
                      v-model="innerFilterForm.numberStudentCancelLesson"
                      type="number"
                      @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                      min="0"
                    >
                      <template v-slot:append>
                        buổi
                      </template>
                      <template v-slot:prepend-inner>
                        <v-select
                          hide-details
                          style="width: 130px; padding: 0"
                          clearable
                          dense
                          placeholder="So sánh"
                          class="custom-solo-select mt-0"
                          solo
                          item-value="value"
                          item-text="label"
                          :items="commonCompareOptions"
                          v-model="innerFilterForm.typeStudentCancelLesson"
                        >
                        </v-select>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row v-if="$route.query.schoolLevel === 'primary'">
                  <v-col cols="5" class="d-flex align-center pl-6">
                    <v-checkbox
                      label="Đổi giáo viên cover"
                      hide-details
                      class="mt-0"
                      light
                      color="green"
                      on-icon="mdi-checkbox-outline"
                      v-model="specialCareFilter.studentChangeTeacherCover"
                      @change="(val) => {
                          if(!val) {
                            innerFilterForm.numberStudentChangeTeacherCover = ''
                            innerFilterForm.typeStudentChangeTeacherCover = ''
                          }
                        }"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      class="custom-compare-input"
                      :disabled="!specialCareFilter.studentChangeTeacherCover"
                      v-model="innerFilterForm.numberStudentChangeTeacherCover"
                      type="number"
                      @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ?  $event.preventDefault() : null"
                      min="0"
                    >
                      <template v-slot:append>
                        buổi
                      </template>
                      <template v-slot:prepend-inner>
                        <v-select
                          hide-details
                          style="width: 130px; padding: 0"
                          dense
                          placeholder="So sánh"
                          class="custom-solo-select mt-0"
                          solo
                          item-value="value"
                          item-text="label"
                          :items="commonCompareOptions"
                          v-model="innerFilterForm.typeStudentChangeTeacherCover"
                          clearable
                        >
                        </v-select>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="d-flex align-center pl-6">
                    <v-checkbox
                      :label="$route.query.schoolLevel === 'primary' ? 'Đổi giáo viên chính' : 'Đổi giáo viên'"
                      hide-details
                      class="mt-0"
                      light
                      color="green"
                      on-icon="mdi-checkbox-outline"
                      v-model="specialCareFilter.studentChangeTeacher"
                      @change="(val) => {
                          if(!val) {
                            innerFilterForm.numberStudentChangeTeacher = ''
                            innerFilterForm.typeStudentChangeTeacher = ''
                          }
                        }"
                    >
                    </v-checkbox>
                  </v-col>
                  <v-col cols="7">
                    <v-text-field
                      outlined
                      dense
                      hide-details
                      class="custom-compare-input"
                      :disabled="!specialCareFilter.studentChangeTeacher"
                      v-model="innerFilterForm.numberStudentChangeTeacher"
                      type="number"
                      @keydown="$event.key === '-' || $event.key === 'e' || $event.key === '.' ? $event.preventDefault() : null"
                      min="0"
                    >
                      <template v-slot:append>
                        {{$route.query.schoolLevel === 'primary' ? 'lần' : 'buổi'}}
                      </template>
                      <template v-slot:prepend-inner>
                        <v-select
                          hide-details
                          style="width: 130px; padding: 0"
                          clearable
                          dense
                          placeholder="So sánh"
                          class="custom-solo-select mt-0"
                          solo
                          item-value="value"
                          item-text="label"
                          :items="commonCompareOptions"
                          v-model="innerFilterForm.typeStudentChangeTeacher"
                        >
                        </v-select>
                      </template>
                    </v-text-field>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12" v-if="$route.query.schoolLevel === 'primary'">
                <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thông tin học sinh</div>
                <v-row>
                  <v-col cols="5" class="d-flex align-center pl-6">
                    Chương trình (Tutor)
                  </v-col>
                  <v-col cols="7">
                    <v-menu
                      bottom
                      offset-y
                      content-class="menu-wrapper-tree-user"
                      :close-on-content-click="false">
                      <template v-slot:activator="{ on, attrs }">
                        <div
                          v-if="(innerFilterForm.programFilter.length === 0 && programFilterType === 1) || (innerFilterForm.curriculumIds.length === 0 && programFilterType === 2)"
                          v-bind="attrs"
                          v-on="on">
                          <v-select
                            label="Chương trình (Tutor)"
                            readonly
                            hide-details
                            placeholder="Tìm kiếm theo chương trình "
                            outlined
                            dense
                          >
                          </v-select>
                        </div>
                        <div
                          v-bind="attrs"
                          v-on="on"
                          v-else
                          style="position: relative"
                        >
                          <div class="mt-1 tree-user-selected" v-show="programFilterType === 1">
                            <span
                              v-for="(node, index) in computedLevelName"
                              :key="node + index"
                            >
                              <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItemProgram(node, programFilterType, index)">
                                {{ handleCutChipText(node, 30) }}
                              </v-chip>
                            </span>
                          </div>
                          <div class="mt-1 tree-user-selected" v-show="programFilterType === 2">
                                <span
                                  v-for="(node, index) in computedProgramName"
                                  :key="node + index"
                                >
                                  <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItemProgram(node, programFilterType, index)">
                                    {{ handleCutChipText(node, 30) }}
                                  </v-chip>
                                </span>
                          </div>
                          <v-icon
                            class="icon-clear-all"
                            color="grey"
                            @click="removeProgramLevelSelected()">mdi-trash-can-outline
                          </v-icon>
                        </div>
                      </template>
                      <template>
                        <div style="background: white; max-height: 400px; overflow: auto; padding: 0 12px">
                          <v-radio-group
                            style="justify-content: center"
                            class="custom-radio-group"
                            v-model="programFilterType"
                            row
                            hide-details
                          >
                            <v-radio
                              label="Chọn theo level"
                              :value="1"
                            ></v-radio>
                            <v-radio
                              label="Chọn theo chương trình"
                              :value="2"
                            ></v-radio>
                          </v-radio-group>
                          <v-text-field
                            class="px-6 pt-4"
                            label="Tìm kiếm..."
                            v-model="search"
                            hide-details
                          >
                          </v-text-field>
                          <v-treeview
                            v-show="programFilterType === 1"
                            v-model="innerFilterForm.programFilter"
                            :search="search"
                            selectable
                            item-key="fakeId"
                            item-disabled="locked"
                            return-object
                            :items="treeListProgram"
                          ></v-treeview>
                          <v-treeview
                            v-show="programFilterType === 2"
                            v-model="innerFilterForm.curriculumIds"
                            selectable
                            :items="listProgram"
                            :search="search"
                            item-text="title"
                            item-key="id"
                          ></v-treeview>
                        </div>
                      </template>
                    </v-menu>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="d-flex align-center pl-6">
                    Trạng thái học
                  </v-col>
                  <v-col cols="7">
                    <v-autocomplete
                      v-model="innerFilterForm.studentStatusTutor"
                      :items="HS_STATUSES ? HS_STATUSES : []"
                      item-text="name"
                      item-value="id"
                      placeholder="Chọn trạng thái"
                      no-data-text="Không có dữ liệu"
                      clearable
                      multiple
                      hide-details
                      persistent-placeholder
                      outlined
                      dense
                      chips
                      clear-icon="mdi-trash-can-outline"
                    >
                      <template #selection="{item}">
                        <v-chip color="#F8E5FF" close close-icon="mdi-close" @click:close="removeItem(innerFilterForm.studentStatusTutor, item.id)">
                          {{item.name}}
                        </v-chip>
                      </template>
                    </v-autocomplete>
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <div style="font-weight: bold; color: #5B5B5B; margin-bottom: 8px">Thời gian</div>
                <v-row v-if="$route.query.schoolLevel === 'primary'">
                  <v-col cols="5" class="d-flex align-center pl-6">
                    Ngày hết hạn
                  </v-col>
                  <v-col cols="7">
                    <common-range-picker
                      :disabled="true"
                      :clearable="true"
                      :aLight="'left'"
                      v-model="innerFilterForm.endDate"
                      @check-close-on-click="checkCloseOnClick"
                      class="show-date"
                      isFilter
                      noneMargin
                    ></common-range-picker>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="5" class="d-flex align-center pl-6">
                    Ngày vào danh sách
                  </v-col>
                  <v-col cols="7">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'left'"
                      v-model="innerFilterForm.specialInAt"
                      class="show-date"
                      isFilter
                      noneMargin
                      @check-close-on-click="checkCloseOnClick"
                    ></common-range-picker>
                  </v-col>
                </v-row>
                <v-row v-if="$route.query.schoolLevel === 'secondary'">
                  <v-col cols="5" class="d-flex align-center pl-6">
                    Hạn chăm sóc bắt buộc
                  </v-col>
                  <v-col cols="7">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'left'"
                      v-model="innerFilterForm.specialOutDateAt"
                      class="show-date"
                      isFilter
                      noneMargin
                      @check-close-on-click="checkCloseOnClick"
                    ></common-range-picker>
                  </v-col>
                </v-row>
                <v-row v-if="$route.query.schoolLevel === 'secondary'">
                  <v-checkbox
                    label="Quá hạn chăm sóc"
                    v-model="checkisSpecialOutDate"
                    class="pl-6"
                  ></v-checkbox>
                </v-row>
                <v-row v-if="$route.query.schoolLevel === 'primary'">
                  <v-col cols="5" class="d-flex align-center pl-6" style="line-height: 1.5">
                    Ngày kiểm tra sắp tới
                  </v-col>
                  <v-col cols="7">
                    <common-range-picker
                      :clearable="true"
                      :aLight="'left'"
                      v-model="innerFilterForm.nextTestDate"
                      class="'show-date"
                      @check-close-on-click="checkCloseOnClick"
                      isFilter
                      noneMargin
                    ></common-range-picker>
                  </v-col>
                </v-row>
              </v-col>
            </div>
          </v-row>
          <v-divider style="margin-bottom: 20px; margin-top: 20px"></v-divider>
          <div class="text-center mb-4">
            <v-btn
              class="primary mx-2"
              @click="searchContact"
              style="background-color: #e91e63 !important"
            >
              Áp dụng bộ lọc
            </v-btn>
            <v-btn
              class="primary mx-2"
              @click="downloadExcel()"
            >
              <v-icon>mdi-download</v-icon>Download
            </v-btn>
          </div>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-card>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { HS_STATUSES } from '@/helpers/constant';
import levelSublevel from '@/mixins/levelSublevel';

export default {
  props: {
    tutorPriority: {
      type: Number,
      required: true,
    },
    filterForm: {
      type: Object,
      default: () => {},
    },
  },
  mixins: [levelSublevel],
  data() {
    return {
      required: false,
      HS_STATUSES,
      search: '',
      programFilterType: 1,
      closeOnClickOutside: true,
      commonCompareOptions: [
        {
          value: 'lt',
          label: 'Nhỏ hơn',
        },
        {
          value: 'gt',
          label: 'Lớn hơn',
        },
        {
          value: 'eq',
          label: 'Bằng',
        },
      ],
      specialCareFilter: {
        studentOff: false,
        studentLateEarly: false,
        studentHw: false,
        studentTestLow: false,
        studentCancelLesson: false,
        studentChangeTeacher: false,
        studentChangeTeacherCover: false,
      },
      checkisSpecialOutDate: false,
      innerFilterForm: {},
    };
  },
  watch: {
    programFilterType(val) {
      if (val === 1) {
        this.innerFilterForm.curriculumIds = [];
      } else {
        this.innerFilterForm.programFilter = [];
      }
    },
    '$route.name': function () {
      this.specialCareFilter = {
        studentOff: false,
        studentLateEarly: false,
        studentHw: false,
        studentTestLow: false,
        studentCancelLesson: false,
        studentChangeTeacher: false,
      };
    },
    closeOnClickOutside(val) {
      this.$emit('change-close-on-click', val);
    },
    filterForm: {
      handler(val) {
        this.innerFilterForm = _.cloneDeep(val);
      },
      deep: true,
    },
    checkisSpecialOutDate(val) {
      if (val) {
        this.innerFilterForm.isSpecialOutDate = 1;
      } else {
        this.innerFilterForm.isSpecialOutDate = 0;
      }
    },
  },
  computed: {
    ...mapState('student_care', ['listGVCNV2', 'listProgram']),
    computedProgramName() {
      return this.listProgram.filter((e) => this.innerFilterForm.curriculumIds.includes(e.id)).map((e) => e.title);
    },
    computedLevelName() {
      return this.innerFilterForm.programFilter.map((e) => e.programLevelName);
    },
  },
  created() {
    this.innerFilterForm = _.cloneDeep(this.filterForm);
    this.getListGVCNV2();
  },
  methods: {
    ...mapActions('student_care', ['getListGVCNV2']),
    downloadExcel() {
      Bus.$emit('download-excel-filter', {
        ...this.innerFilterForm,
        school_level: this.$route.query.schoolLevel,
        typeBlended: this.tutorPriority,
      });
    },
    changeNumberLastCare(type) {
      if (!(Number.isInteger(Number(this.innerFilterForm.numberLastestCareDateFrom)) && Number(this.innerFilterForm.numberLastestCareDateFrom) >= 0)) this.innerFilterForm.numberLastestCareDateFrom = null;
      if (!(Number.isInteger(Number(this.innerFilterForm.numberLastestCareDateTo)) && Number(this.innerFilterForm.numberLastestCareDateTo) >= 0)) this.innerFilterForm.numberLastestCareDateTo = null;
      if ((type === 'from' && Number(this.innerFilterForm.numberLastestCareDateFrom) > Number(this.innerFilterForm.numberLastestCareDateTo) && this.innerFilterForm.numberLastestCareDateTo !== null) || (type === 'to' && Number(this.innerFilterForm.numberLastestCareDateTo) < Number(this.innerFilterForm.numberLastestCareDateFrom) && this.innerFilterForm.numberLastestCareDateFrom !== null)) {
        this.required = true;
      } else {
        this.required = false;
      }
    },
    removeProgramLevelSelected() {
      if (this.programFilterType === 1) {
        this.innerFilterForm.programFilter = [];
      } else {
        this.innerFilterForm.curriculumIds = [];
      }
    },
    handleCutChipText(text, number = 20) {
      return text.length > number ? `${text.slice(0, number - 2)}...` : text;
    },
    removeItemProgram(node, programFilterType, index) {
      // eslint-disable-next-line no-unused-expressions
      programFilterType === 1 ? this.innerFilterForm.programFilter.splice(index, 1) : this.innerFilterForm.curriculumIds.splice(index, 1);
    },
    checkCloseOnClick(val) {
      this.closeOnClickOutside = !val;
    },
    validateSpecialFilter() {
      if ((this.specialCareFilter.studentHw && (!this.innerFilterForm.numberStudentHw || !this.innerFilterForm.typeStudentHw))
        || (this.specialCareFilter.studentOff && (!this.innerFilterForm.numberStudentOff || !this.innerFilterForm.typeStudentOff))
        || (this.specialCareFilter.studentChangeTeacher && (!this.innerFilterForm.numberStudentChangeTeacher || !this.innerFilterForm.typeStudentChangeTeacher))
        || (this.specialCareFilter.studentLateEarly && (!this.innerFilterForm.numberStudentLateEarly || !this.innerFilterForm.typeStudentLateEarly))
        || (this.specialCareFilter.studentCancelLesson && (!this.innerFilterForm.numberStudentCancelLesson || !this.innerFilterForm.typeStudentCancelLesson))
      ) {
        this.closeOnClickOutside = false;
        this.$swal({
          type: 'error',
          title: 'Lỗi !',
          text: 'Vui lòng chọn điều kiện so sánh!',
        }).then(() => {
          this.closeOnClickOutside = true;
        });
        return false;
      } return true;
    },
    removeItem(items, item) {
      const index = items.indexOf(item);
      if (index >= 0) items.splice(index, 1);
    },
    closeMenuPopup() {
      this.$emit('close');
    },
    searchContact() {
      if (this.required) return;
      if (!this.validateSpecialFilter()) {
        return;
      }
      this.$emit('searchContact', this.innerFilterForm);
    },
    toggleSelectTeacher() {
      this.searchInputTeacher = '';
      this.$nextTick(() => {
        if (this.innerFilterForm.homeroomTeacherIds.length > 0) {
          this.innerFilterForm.hasNoTeacher = false;
        }
      });
    },
    toggleHasNoTeacher() {
      this.$nextTick(() => {
        this.innerFilterForm.hasNoTeacher = !this.innerFilterForm.hasNoTeacher;
        this.innerFilterForm.homeroomTeacherIds = [];
      });
    },
  },
};
</script>

<style lang="css">
.tree-user-selected {
  min-height: 34px;
  overflow-y: auto;
  border: 1px solid #d2d2d2;
  border-radius: 4px;
  display: flex;
  flex-wrap: wrap;
  row-gap: 4px;
  column-gap: 4px;
  padding: 8px 40px 8px 8px;
}
.custom-compare-input .v-input__prepend-inner {
  margin-top: 0px !important;
}
.custom-compare-input .v-input__append-inner {
  margin-top: 14px !important;
}
.custom-solo-select.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {
  box-shadow: none !important;
  padding: 0;
}
.custom-solo-select .v-input__append-inner {
  margin-top: 0 !important;
}
</style>
